import React from "react";
import { Document, Page } from "react-pdf";
import "./file-viewer.style.scss";
export default function FileViewer({ file, closeIt }) {
  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div onClick={() => closeIt()} className="file-viewer-main">
      <div onClick={(e) => e.stopPropagation()} className="file-viewer-wrapper">
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    </div>
  );
}
